import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const SriLankaTable = ({ usersInfo, downloadFile, checkUser }) => {
  const renderFileLink = (fileName, label) => {
    if (!fileName) return "-";
    return (
      <p className="link" onClick={() => downloadFile(fileName)}>
        {label}
      </p>
    );
  };

  return (
    <TableContainer component={Paper}>
      <Table aria-label="group table" className="group-info-table">
        <TableHead className="group-info-table-head">
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>שם מלא</TableCell>
            <TableCell>טלפון</TableCell>
            <TableCell>כתובת</TableCell>
            <TableCell>תאריך כניסה</TableCell>
            <TableCell>שם מלון</TableCell>
            <TableCell>תמונה של הדַרכּוֹן</TableCell>
            <TableCell>הושלם</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {usersInfo.map((user, index) => (
            <TableRow key={user._id}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{user.fullName}</TableCell>
              <TableCell>{user.phone}</TableCell>
              <TableCell>{user.address}</TableCell>
              <TableCell>{user.entryDate}</TableCell>
              <TableCell>{user.hotelName}</TableCell>
              <TableCell>{renderFileLink(user.pictureOfPassportFileName, "הורד צילום דַרכּוֹן")}</TableCell>
              <TableCell>
                <div className="custom-checkbox" onClick={() => checkUser(user._id, user.checked, index)}>
                  {user.checked ? <div className="check">&#10004;</div> : ""}
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SriLankaTable;
